var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _path8, _path9, _path0, _rect6, _rect7, _rect8, _rect9, _circle3, _circle4, _circle5, _path1, _path10, _rect0, _rect1, _rect10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNegativeKeywordsNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80.7773,
    y: 103.093,
    width: 50,
    height: 10,
    rx: 5,
    stroke: "#192657",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80.7773,
    y: 123.093,
    width: 32,
    height: 10,
    rx: 5,
    stroke: "#192657",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 121.777,
    y: 123.093,
    width: 17,
    height: 10,
    rx: 5,
    stroke: "#192657",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 148.777,
    y: 123.093,
    width: 29,
    height: 10,
    rx: 5,
    stroke: "#192657",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 187.777,
    y: 123.093,
    width: 48,
    height: 10,
    rx: 5,
    stroke: "#192657",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.777 108.093C140.777 105.332 143.016 103.093 145.777 103.093H165.777C168.539 103.093 170.777 105.332 170.777 108.093C170.777 110.855 168.539 113.093 165.777 113.093H145.777C143.016 113.093 140.777 110.855 140.777 108.093Z",
    stroke: "#192657",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180.777 108.093C180.777 105.332 183.016 103.093 185.777 103.093H188.777C191.539 103.093 193.777 105.332 193.777 108.093C193.777 110.855 191.539 113.093 188.777 113.093H185.777C183.016 113.093 180.777 110.855 180.777 108.093Z",
    stroke: "#192657",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M203.777 108.093C203.777 105.332 206.016 103.093 208.777 103.093H230.777C233.539 103.093 235.777 105.332 235.777 108.093C235.777 110.855 233.539 113.093 230.777 113.093H208.777C206.016 113.093 203.777 110.855 203.777 108.093Z",
    stroke: "#192657",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2773 133.593V195.093",
    stroke: "#528FF5",
    strokeWidth: 2,
    strokeDasharray: "5 5 5 5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.777 171.093H83.7773C81.5682 171.093 79.7773 172.884 79.7773 175.093V191.093C79.7773 193.302 81.5682 195.093 83.7773 195.093H104.777",
    stroke: "#192657",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211.777 171.093H232.777C234.986 171.093 236.777 172.884 236.777 175.093V191.093C236.777 193.302 234.986 195.093 232.777 195.093H211.777",
    stroke: "#192657",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 157.777,
    cy: 187.093,
    r: 45,
    stroke: "#F58120",
    strokeWidth: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.777,
    cy: 187.093,
    r: 36,
    stroke: "#192657",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M186.848 224.034L199.709 239.153",
    stroke: "#F58120",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M195.777 245.07L210.996 232.093L240.193 266.335C243.777 270.538 243.275 276.85 239.072 280.433C234.87 284.016 228.558 283.514 224.975 279.312L195.777 245.07Z",
    fill: "#192657"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M193.187 245.182L206.884 233.503L235.432 266.984C238.657 270.766 238.206 276.447 234.423 279.672C230.641 282.897 224.961 282.445 221.736 278.663L193.187 245.182Z",
    stroke: "#528FF5",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M178.857 173.073L169.857 202.093H164.437L158.497 183.113C158.404 182.847 158.311 182.553 158.217 182.233C158.124 181.913 158.037 181.573 157.957 181.213C157.877 181.573 157.791 181.913 157.697 182.233C157.604 182.553 157.511 182.847 157.417 183.113L151.417 202.093H145.977L136.997 173.073H142.037C142.557 173.073 142.991 173.193 143.337 173.433C143.697 173.673 143.931 173.993 144.037 174.393L148.537 190.753C148.644 191.207 148.751 191.7 148.857 192.233C148.977 192.753 149.091 193.307 149.197 193.893C149.317 193.293 149.444 192.733 149.577 192.213C149.711 191.693 149.857 191.207 150.017 190.753L155.257 174.393C155.364 174.06 155.591 173.76 155.937 173.493C156.297 173.213 156.731 173.073 157.237 173.073H158.997C159.517 173.073 159.937 173.2 160.257 173.453C160.591 173.693 160.837 174.007 160.997 174.393L166.217 190.753C166.377 191.18 166.524 191.647 166.657 192.153C166.791 192.647 166.917 193.173 167.037 193.733C167.144 193.173 167.244 192.647 167.337 192.153C167.444 191.647 167.551 191.18 167.657 190.753L172.157 174.393C172.251 174.047 172.477 173.74 172.837 173.473C173.197 173.207 173.631 173.073 174.137 173.073H178.857Z",
    fill: "#528FF5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 72.7773,
    y: 248.093,
    width: 59,
    height: 4,
    rx: 2,
    fill: "#F58120"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 251.777,
    y: 154.093,
    width: 30,
    height: 4,
    rx: 2,
    fill: "#528FF5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 268.777,
    y: 141.093,
    width: 30,
    height: 4,
    rx: 2,
    transform: "rotate(90 268.777 141.093)",
    fill: "#528FF5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 82.7773,
    y: 258.093,
    width: 59,
    height: 4,
    rx: 2,
    fill: "#528FF5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.7773,
    cy: 211.093,
    r: 8,
    fill: "#F58120"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.777,
    cy: 111.093,
    r: 16,
    stroke: "#F58120",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.777,
    cy: 223.093,
    r: 11,
    stroke: "#F58120",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M297.277 262.093V311.593H228.277",
    stroke: "#192657",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M292.777 307.093V266.093C289.777 268.76 283.077 276.993 280.277 288.593C276.777 303.093 241.277 294.593 238.777 307.093H292.777Z",
    fill: "#F58120"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 63.7773,
    y: 75.0933,
    width: 12,
    height: 12,
    fill: "#528FF5"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 83.7773,
    y: 75.0933,
    width: 12,
    height: 12,
    fill: "#528FF5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 103.777,
    y: 75.0933,
    width: 12,
    height: 12,
    fill: "#528FF5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M266.276 152.593C277.442 96.7597 269.376 -5.20696 147.776 33.593C-4.22449 82.093 -0.224491 256.093 79.2755 295.093C158.776 334.093 277.277 357.093 315.777 277.593C346.577 213.993 254.277 183.427 204.277 176.093",
    stroke: "black",
    strokeDasharray: "2 2 2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegativeKeywordsNew);
export default __webpack_public_path__ + "static/media/NegativeKeywordsNew.538faece4de85dc2e40e5a02522cf4e1.svg";
export { ForwardRef as ReactComponent };